import { render, staticRenderFns } from "./ProjectRiskManageModal.vue?vue&type=template&id=c3bf14a8&"
import script from "./ProjectRiskManageModal.vue?vue&type=script&lang=js&"
export * from "./ProjectRiskManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports